var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-message-wrap" },
    [
      _vm._l(_vm.allMessages, function (message, i) {
        return [
          message.key === _vm.historyFromKey
            ? [
                _c("seminar-entry-message-history-from-applicant", {
                  key: i,
                  attrs: {
                    body: message.body,
                    subject: message.subject,
                    date: message.date,
                  },
                  on: { "set-body-and-subject": _vm.setBodyAndSubject },
                }),
              ]
            : message.key === _vm.historyToKey
            ? [
                _c("seminar-entry-message-history-to-applicant", {
                  key: i,
                  attrs: {
                    body: message.body,
                    subject: message.subject,
                    date: message.date,
                    "is-read": message.isRead,
                    "interview-adjustment": message.interviewAdjustment,
                    "is-remind-mail": message.isRemindMail,
                  },
                }),
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }